import { render, staticRenderFns } from "./BaseTableWithPagination.vue?vue&type=template&id=c09a3bc6&scoped=true"
import script from "./BaseTableWithPagination.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTableWithPagination.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseTableWithPagination.vue?vue&type=style&index=0&id=c09a3bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c09a3bc6",
  null
  
)

export default component.exports